<template>
    <div>
        <el-form :model="form">
            <el-form-item label="轮播图名称" :label-width="formLabelWidth">
                <el-input v-model="form.bannerName" autocomplete="off" placeholder="请填写轮播图名称"></el-input>
            </el-form-item>
            <el-form-item label="轮播图片" :label-width="formLabelWidth">
                <div class="chooseImg" @click="chooseImg">
                    <i class="el-icon-plus" v-if="imageUrl == ''"></i>
                    <img v-if="imageUrl != ''" :src="imageUrl" mode="scaleToFill" />
                </div>
                <div class="tips">轮播图片请上传 690 * 300 格式图片</div>
            </el-form-item>
            <el-form-item label="位置" :label-width="formLabelWidth">
                <el-select v-model="form.position" placeholder="请选择位置" clearable>
                    <el-option label="首页" :value="0"></el-option>
                    <el-option label="商学院" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="跳转方式" :label-width="formLabelWidth">
                <el-radio v-model="form.jumpMode" :label="0">外部链接</el-radio>
                <el-radio v-model="form.jumpMode" :label="1">内部链接</el-radio>
                <el-radio v-model="form.jumpMode" :label="2">图文内容</el-radio>

                <el-input v-model="form.links" autocomplete="off" placeholder="请填写外部链接"
                    v-if="form.jumpMode == 0"></el-input>
            </el-form-item>
            <el-form-item v-if="form.jumpMode == 1" label="内部链接" :label-width="formLabelWidth">
                <el-radio v-model="internalLinkType" :label="0">自定义</el-radio>
                <el-radio v-model="internalLinkType" :label="1">选择商品链接</el-radio>

                <el-input v-model="form.links" autocomplete="off" placeholder="请填写外部链接"
                    v-if="internalLinkType == 0"></el-input>
                <div @click="shopListFunc">
                    <el-input v-model="productName" autocomplete="off" placeholder="请选择商品名称" :readonly="true"
                        v-if="internalLinkType == 1"></el-input>
                </div>
            </el-form-item>
            <el-form-item v-show="form.jumpMode == 2" label="图文内容" :label-width="formLabelWidth">
                <Uediter :text="form.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc">
                </Uediter>
            </el-form-item>

            <el-form-item label="排序" :label-width="formLabelWidth">
                <el-input v-model="form.sort" autocomplete="off" placeholder="请填写排序"></el-input>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth">
                <el-select v-model="form.state" placeholder="请选择状态" clearable>
                    <el-option label="上架" :value="0"></el-option>
                    <el-option label="下架" :value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="addVersions">确 定</el-button>
        </div>
        <Upload v-if="isProductUpload" :isupload="isProductUpload" :config="selectorConfig" @returnImgs="handleReturnImgs">
        </Upload>

        <el-dialog title="内部链接" :visible.sync="insideLink" :show-close="false" :close-on-click-modal="false" append-to-body>
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
                style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="productName" label="产品名称">
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancelLink">取 消</el-button>
                <el-button type="primary" @click="handleCancelLink">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ProductApi from '@/api/product.js'
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
import bannerApi from '@/api/setting/banner.js'
export default {
    components: {
        Upload, Uediter
    },
    props: ['itemDataList'],
    data() {
        return {
            form: {
                position: this.itemDataList ? this.itemDataList.position : '',
                bannerName: this.itemDataList ? this.itemDataList.bannerName : '',
                links: this.itemDataList ? this.itemDataList.links : '',
                content: this.itemDataList ? this.itemDataList.content : '',
                jumpMode: this.itemDataList ? this.itemDataList.jumpMode : '',
                sort: this.itemDataList ? this.itemDataList.sort : '',
                state: this.itemDataList ? this.itemDataList.state : '',
                id: this.itemDataList ? this.itemDataList.id : '',
            },
            selectorConfig: {
                total: 1,
                multiple: false,
                fileType: "image",
            },
            /*富文本框配置*/
            ueditor: {
                config: {
                    initialFrameWidth: 400,
                    initialFrameHeight: 500
                },
            },
            formLabelWidth: '120px',
            /*是否打开图片选择*/
            isupload: true,
            imageUrl: this.itemDataList ? this.itemDataList.bannerPicture : '', // 上传图片
            isProductUpload: false,
            insideLink: false, // 内部链接打开变量
            activeName: 'first',
            loading: true,
            lastSelected: null,
            internalLinkType: this.itemDataList ? this.itemDataList.internalLinkType : null, // 自定义/选中商品
            tableData: [],
            productName: this.itemDataList ? this.itemDataList.productName : '',
        }
    },
    methods: {
        // 选择商品列表
        shopListFunc() {
            ProductApi.productList({ type: "sell", pageIndex: 1, pageSize: 15 }).then(res => {
                this.loading = false
                this.tableData = res.data.productList.records
            })
            this.insideLink = true
            // console.log(this.insideLink)
        },
        // 多选框
        handleSelectionChange(selection) {
            if (selection.length > 1) {
                // 取消前面选中的项
                selection.forEach(item => {
                    if (item !== this.lastSelected) {
                        this.$refs.multipleTable.toggleRowSelection(item, false)
                    }
                })
                // 选择最后选中的项
                this.lastSelected = selection[selection.length - 1]
            } else if (selection.length === 1) {
                // 记录当前选中的项
                this.lastSelected = selection[0]
                this.form.links = this.lastSelected.productId;
                this.productName = this.lastSelected.productName
                // console.log(this.lastSelected.productName)
            } else {
                // 没有选中任何项
                this.lastSelected = null
            }
        },
        // 内部链接弹窗的tab事件
        handleClick(tab, event) {
            // console.log(tab.index);
            this.internalLinkType = tab.index
        },
        // 内部链接弹窗的取消按钮
        handleCancelLink() {
            this.insideLink = false;
        },
        /*获取富文本内容*/
        contentChangeFunc(e) {
            this.form.content = e;
        },
        handleReturnImgs(imgList) {
            if (imgList) {
                // console.log(imgList[0]);
                this.imageUrl = imgList[0].filePath;
                this.isProductUpload = false;
            } else {
                // 用户取消了选择
                // console.log("用户取消了选择");
                this.isProductUpload = false;
                // console.log(this.isProductUpload)
            }

        },
        /*上传商品图片*/
        chooseImg() {
            this.isProductUpload = true
        },
        // 关闭组件
        handleCancel() {
            this.$emit('closeFunction') // 传递数据给父组件
        },
        // 确定（新增）
        addVersions() {
            // 判断每一项都填了才能继续执行
            console.log(this.form, this.imageUrl == '');
            if (!this.form.bannerName.trim() || this.imageUrl == '' || this.form.position === '' || this.form.sort === '') {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });
                return;
            }
            let requestUrl = bannerApi.getAddBanner
            const params = {
                position: this.form.position,
                bannerName: this.form.bannerName,
                links: this.form.links,
                content: this.form.content,
                jumpMode: this.form.jumpMode,
                sort: this.form.sort,
                state: this.form.state,
                bannerPicture: this.imageUrl,
                internalLinkType: this.internalLinkType
            }
            if (this.form.id) {
                params.id = this.form.id
                requestUrl = bannerApi.getUpdateBanner
            }
            // 新增 请求
            requestUrl({ ...params }).then(response => {
                this.$message({
                    message: params.id ? '编辑成功' : '新增成功',
                    type: 'success'
                });
                this.handleCancel();
            }).catch(error => {
                // console.error(error);
            });
        },
        // 上传图片
        handleAvatarSuccess(res, file) {
            // console.log(res, file);
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const typeArry = ['.jpg', '.png', '.bmp', '.JPG', '.PNG', '.BMP', '.gif', '.GIF'];
            const type = file.name.substring(file.name.lastIndexOf('.'));
            const isImage = typeArry.indexOf(type) > -1;
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isImage) {
                this.$message.error('上传文件必须为图片');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
            }
            return isImage && isLt2M;
        }
    },
    watch: {
        "form.jumpMode"(newVal) {
            if (newVal === '1') {
                this.form.links = ""
                this.form.content = ""

            } else {
                this.form.links = ""
                this.form.content = ""
                // this.insideLink = false;
            }
        },
        "internalLinkType"(newVal) {
            this.form.links = "";
            if (newVal == '1') {

                this.shopListFunc();
                this.insideLink = true;
            } else {
                this.insideLink = false;
            }
        }
    },
}
</script>

<style scoped>
.tips {
    color: #ccc;
    font-size: 12px;
}

.chooseImg {
    width: 110px;
    height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
    overflow: hidden;


}

.chooseImg img {
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/banner/components/AddView.vue